import { render, staticRenderFns } from "./Universe.vue?vue&type=template&id=5e008c7e&scoped=true&"
import script from "./Universe.vue?vue&type=script&lang=js&"
export * from "./Universe.vue?vue&type=script&lang=js&"
import style0 from "./Universe.vue?vue&type=style&index=0&id=5e008c7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e008c7e",
  null
  
)

export default component.exports